"use strict";
( () => {
    var On = Object.create;
    var Rt = Object.defineProperty;
    var Mn = Object.getOwnPropertyDescriptor;
    var bn = Object.getOwnPropertyNames;
    var vn = Object.getPrototypeOf
      , Dn = Object.prototype.hasOwnProperty;
    var Nn = (n, o) => () => (o || n((o = {
        exports: {}
    }).exports, o),
    o.exports);
    var kn = (n, o, l, r) => {
        if (o && typeof o == "object" || typeof o == "function")
            for (let h of bn(o))
                !Dn.call(n, h) && h !== l && Rt(n, h, {
                    get: () => o[h],
                    enumerable: !(r = Mn(o, h)) || r.enumerable
                });
        return n
    }
    ;
    var Pn = (n, o, l) => (l = n != null ? On(vn(n)) : {},
    kn(o || !n || !n.__esModule ? Rt(l, "default", {
        value: n,
        enumerable: !0
    }) : l, n));
    var Ot = Nn( (ke, Pe) => {
        (function(n, o) {
            typeof ke == "object" && typeof Pe < "u" ? Pe.exports = o() : typeof define == "function" && define.amd ? define(o) : (n = typeof globalThis < "u" ? globalThis : n || self,
            n.DOMPurify = o())
        }
        )(ke, function() {
            "use strict";
            let {entries: n, setPrototypeOf: o, isFrozen: l, getPrototypeOf: r, getOwnPropertyDescriptor: h} = Object
              , {freeze: c, seal: u, create: H} = Object
              , {apply: b, construct: U} = typeof Reflect < "u" && Reflect;
            c || (c = function(s) {
                return s
            }
            ),
            u || (u = function(s) {
                return s
            }
            ),
            b || (b = function(s, g, p) {
                return s.apply(g, p)
            }
            ),
            U || (U = function(s, g) {
                return new s(...g)
            }
            );
            let ie = M(Array.prototype.forEach)
              , Ge = M(Array.prototype.pop)
              , W = M(Array.prototype.push)
              , se = M(String.prototype.toLowerCase)
              , me = M(String.prototype.toString)
              , ze = M(String.prototype.match)
              , K = M(String.prototype.replace)
              , Gt = M(String.prototype.indexOf)
              , zt = M(String.prototype.trim)
              , v = M(Object.prototype.hasOwnProperty)
              , w = M(RegExp.prototype.test)
              , X = $t(TypeError);
            function M(m) {
                return function(s) {
                    for (var g = arguments.length, p = new Array(g > 1 ? g - 1 : 0), S = 1; S < g; S++)
                        p[S - 1] = arguments[S];
                    return b(m, s, p)
                }
            }
            function $t(m) {
                return function() {
                    for (var s = arguments.length, g = new Array(s), p = 0; p < s; p++)
                        g[p] = arguments[p];
                    return U(m, g)
                }
            }
            function f(m, s) {
                let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : se;
                o && o(m, null);
                let p = s.length;
                for (; p--; ) {
                    let S = s[p];
                    if (typeof S == "string") {
                        let k = g(S);
                        k !== S && (l(s) || (s[p] = k),
                        S = k)
                    }
                    m[S] = !0
                }
                return m
            }
            function Vt(m) {
                for (let s = 0; s < m.length; s++)
                    v(m, s) || (m[s] = null);
                return m
            }
            function F(m) {
                let s = H(null);
                for (let[g,p] of n(m))
                    v(m, g) && (Array.isArray(p) ? s[g] = Vt(p) : p && typeof p == "object" && p.constructor === Object ? s[g] = F(p) : s[g] = p);
                return s
            }
            function ae(m, s) {
                for (; m !== null; ) {
                    let p = h(m, s);
                    if (p) {
                        if (p.get)
                            return M(p.get);
                        if (typeof p.value == "function")
                            return M(p.value)
                    }
                    m = r(m)
                }
                function g() {
                    return null
                }
                return g
            }
            let $e = c(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"])
              , ge = c(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"])
              , he = c(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"])
              , qt = c(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"])
              , _e = c(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"])
              , jt = c(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"])
              , Ve = c(["#text"])
              , qe = c(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"])
              , Ee = c(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"])
              , je = c(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"])
              , re = c(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"])
              , Yt = u(/\{\{[\w\W]*|[\w\W]*\}\}/gm)
              , Wt = u(/<%[\w\W]*|[\w\W]*%>/gm)
              , Kt = u(/\${[\w\W]*}/gm)
              , Xt = u(/^data-[\-\w.\u00B7-\uFFFF]/)
              , Zt = u(/^aria-[\-\w]+$/)
              , Ye = u(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i)
              , Jt = u(/^(?:\w+script|data):/i)
              , Qt = u(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g)
              , We = u(/^html$/i)
              , en = u(/^[a-z][.\w]*(-[.\w]+)+$/i);
            var Ke = Object.freeze({
                __proto__: null,
                MUSTACHE_EXPR: Yt,
                ERB_EXPR: Wt,
                TMPLIT_EXPR: Kt,
                DATA_ATTR: Xt,
                ARIA_ATTR: Zt,
                IS_ALLOWED_URI: Ye,
                IS_SCRIPT_OR_DATA: Jt,
                ATTR_WHITESPACE: Qt,
                DOCTYPE_NAME: We,
                CUSTOM_ELEMENT: en
            });
            let tn = function() {
                return typeof window > "u" ? null : window
            }
              , nn = function(s, g) {
                if (typeof s != "object" || typeof s.createPolicy != "function")
                    return null;
                let p = null
                  , S = "data-tt-policy-suffix";
                g && g.hasAttribute(S) && (p = g.getAttribute(S));
                let k = "dompurify" + (p ? "#" + p : "");
                try {
                    return s.createPolicy(k, {
                        createHTML(G) {
                            return G
                        },
                        createScriptURL(G) {
                            return G
                        }
                    })
                } catch {
                    return console.warn("TrustedTypes policy " + k + " could not be created."),
                    null
                }
            };
            function Xe() {
                let m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : tn()
                  , s = a => Xe(a);
                if (s.version = "3.1.2",
                s.removed = [],
                !m || !m.document || m.document.nodeType !== 9)
                    return s.isSupported = !1,
                    s;
                let {document: g} = m
                  , p = g
                  , S = p.currentScript
                  , {DocumentFragment: k, HTMLTemplateElement: G, Node: Te, Element: Ze, NodeFilter: Z, NamedNodeMap: sn=m.NamedNodeMap || m.MozNamedAttrMap, HTMLFormElement: an, DOMParser: rn, trustedTypes: le} = m
                  , ce = Ze.prototype
                  , ln = ae(ce, "cloneNode")
                  , cn = ae(ce, "nextSibling")
                  , un = ae(ce, "childNodes")
                  , J = ae(ce, "parentNode");
                if (typeof G == "function") {
                    let a = g.createElement("template");
                    a.content && a.content.ownerDocument && (g = a.content.ownerDocument)
                }
                let L, Q = "", {implementation: Ae, createNodeIterator: dn, createDocumentFragment: fn, getElementsByTagName: pn} = g, {importNode: mn} = p, N = {};
                s.isSupported = typeof n == "function" && typeof J == "function" && Ae && Ae.createHTMLDocument !== void 0;
                let {MUSTACHE_EXPR: Se, ERB_EXPR: Ie, TMPLIT_EXPR: ye, DATA_ATTR: gn, ARIA_ATTR: hn, IS_SCRIPT_OR_DATA: _n, ATTR_WHITESPACE: Je, CUSTOM_ELEMENT: En} = Ke
                  , {IS_ALLOWED_URI: Qe} = Ke
                  , E = null
                  , et = f({}, [...$e, ...ge, ...he, ..._e, ...Ve])
                  , T = null
                  , tt = f({}, [...qe, ...Ee, ...je, ...re])
                  , _ = Object.seal(H(null, {
                    tagNameCheck: {
                        writable: !0,
                        configurable: !1,
                        enumerable: !0,
                        value: null
                    },
                    attributeNameCheck: {
                        writable: !0,
                        configurable: !1,
                        enumerable: !0,
                        value: null
                    },
                    allowCustomizedBuiltInElements: {
                        writable: !0,
                        configurable: !1,
                        enumerable: !0,
                        value: !1
                    }
                }))
                  , ee = null
                  , Le = null
                  , nt = !0
                  , we = !0
                  , ot = !1
                  , it = !0
                  , z = !1
                  , st = !0
                  , B = !1
                  , Ce = !1
                  , Re = !1
                  , $ = !1
                  , ue = !1
                  , de = !1
                  , at = !0
                  , rt = !1
                  , Tn = "user-content-"
                  , Oe = !0
                  , te = !1
                  , V = {}
                  , q = null
                  , lt = f({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"])
                  , ct = null
                  , ut = f({}, ["audio", "video", "img", "source", "image", "track"])
                  , Me = null
                  , dt = f({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"])
                  , fe = "http://www.w3.org/1998/Math/MathML"
                  , pe = "http://www.w3.org/2000/svg"
                  , P = "http://www.w3.org/1999/xhtml"
                  , j = P
                  , be = !1
                  , ve = null
                  , An = f({}, [fe, pe, P], me)
                  , ne = null
                  , Sn = ["application/xhtml+xml", "text/html"]
                  , In = "text/html"
                  , A = null
                  , Y = null
                  , ft = 255
                  , yn = g.createElement("form")
                  , pt = function(e) {
                    return e instanceof RegExp || e instanceof Function
                }
                  , De = function() {
                    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    if (!(Y && Y === e)) {
                        if ((!e || typeof e != "object") && (e = {}),
                        e = F(e),
                        ne = Sn.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? In : e.PARSER_MEDIA_TYPE,
                        A = ne === "application/xhtml+xml" ? me : se,
                        E = v(e, "ALLOWED_TAGS") ? f({}, e.ALLOWED_TAGS, A) : et,
                        T = v(e, "ALLOWED_ATTR") ? f({}, e.ALLOWED_ATTR, A) : tt,
                        ve = v(e, "ALLOWED_NAMESPACES") ? f({}, e.ALLOWED_NAMESPACES, me) : An,
                        Me = v(e, "ADD_URI_SAFE_ATTR") ? f(F(dt), e.ADD_URI_SAFE_ATTR, A) : dt,
                        ct = v(e, "ADD_DATA_URI_TAGS") ? f(F(ut), e.ADD_DATA_URI_TAGS, A) : ut,
                        q = v(e, "FORBID_CONTENTS") ? f({}, e.FORBID_CONTENTS, A) : lt,
                        ee = v(e, "FORBID_TAGS") ? f({}, e.FORBID_TAGS, A) : {},
                        Le = v(e, "FORBID_ATTR") ? f({}, e.FORBID_ATTR, A) : {},
                        V = v(e, "USE_PROFILES") ? e.USE_PROFILES : !1,
                        nt = e.ALLOW_ARIA_ATTR !== !1,
                        we = e.ALLOW_DATA_ATTR !== !1,
                        ot = e.ALLOW_UNKNOWN_PROTOCOLS || !1,
                        it = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1,
                        z = e.SAFE_FOR_TEMPLATES || !1,
                        st = e.SAFE_FOR_XML !== !1,
                        B = e.WHOLE_DOCUMENT || !1,
                        $ = e.RETURN_DOM || !1,
                        ue = e.RETURN_DOM_FRAGMENT || !1,
                        de = e.RETURN_TRUSTED_TYPE || !1,
                        Re = e.FORCE_BODY || !1,
                        at = e.SANITIZE_DOM !== !1,
                        rt = e.SANITIZE_NAMED_PROPS || !1,
                        Oe = e.KEEP_CONTENT !== !1,
                        te = e.IN_PLACE || !1,
                        Qe = e.ALLOWED_URI_REGEXP || Ye,
                        j = e.NAMESPACE || P,
                        _ = e.CUSTOM_ELEMENT_HANDLING || {},
                        e.CUSTOM_ELEMENT_HANDLING && pt(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (_.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck),
                        e.CUSTOM_ELEMENT_HANDLING && pt(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (_.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck),
                        e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (_.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements),
                        z && (we = !1),
                        ue && ($ = !0),
                        V && (E = f({}, Ve),
                        T = [],
                        V.html === !0 && (f(E, $e),
                        f(T, qe)),
                        V.svg === !0 && (f(E, ge),
                        f(T, Ee),
                        f(T, re)),
                        V.svgFilters === !0 && (f(E, he),
                        f(T, Ee),
                        f(T, re)),
                        V.mathMl === !0 && (f(E, _e),
                        f(T, je),
                        f(T, re))),
                        e.ADD_TAGS && (E === et && (E = F(E)),
                        f(E, e.ADD_TAGS, A)),
                        e.ADD_ATTR && (T === tt && (T = F(T)),
                        f(T, e.ADD_ATTR, A)),
                        e.ADD_URI_SAFE_ATTR && f(Me, e.ADD_URI_SAFE_ATTR, A),
                        e.FORBID_CONTENTS && (q === lt && (q = F(q)),
                        f(q, e.FORBID_CONTENTS, A)),
                        Oe && (E["#text"] = !0),
                        B && f(E, ["html", "head", "body"]),
                        E.table && (f(E, ["tbody"]),
                        delete ee.tbody),
                        e.TRUSTED_TYPES_POLICY) {
                            if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function")
                                throw X('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                            if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function")
                                throw X('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                            L = e.TRUSTED_TYPES_POLICY,
                            Q = L.createHTML("")
                        } else
                            L === void 0 && (L = nn(le, S)),
                            L !== null && typeof Q == "string" && (Q = L.createHTML(""));
                        c && c(e),
                        Y = e
                    }
                }
                  , mt = f({}, ["mi", "mo", "mn", "ms", "mtext"])
                  , gt = f({}, ["foreignobject", "annotation-xml"])
                  , Ln = f({}, ["title", "style", "font", "a", "script"])
                  , ht = f({}, [...ge, ...he, ...qt])
                  , _t = f({}, [..._e, ...jt])
                  , wn = function(e) {
                    let t = J(e);
                    (!t || !t.tagName) && (t = {
                        namespaceURI: j,
                        tagName: "template"
                    });
                    let i = se(e.tagName)
                      , d = se(t.tagName);
                    return ve[e.namespaceURI] ? e.namespaceURI === pe ? t.namespaceURI === P ? i === "svg" : t.namespaceURI === fe ? i === "svg" && (d === "annotation-xml" || mt[d]) : !!ht[i] : e.namespaceURI === fe ? t.namespaceURI === P ? i === "math" : t.namespaceURI === pe ? i === "math" && gt[d] : !!_t[i] : e.namespaceURI === P ? t.namespaceURI === pe && !gt[d] || t.namespaceURI === fe && !mt[d] ? !1 : !_t[i] && (Ln[i] || !ht[i]) : !!(ne === "application/xhtml+xml" && ve[e.namespaceURI]) : !1
                }
                  , D = function(e) {
                    W(s.removed, {
                        element: e
                    });
                    try {
                        e.parentNode.removeChild(e)
                    } catch {
                        e.remove()
                    }
                }
                  , Ne = function(e, t) {
                    try {
                        W(s.removed, {
                            attribute: t.getAttributeNode(e),
                            from: t
                        })
                    } catch {
                        W(s.removed, {
                            attribute: null,
                            from: t
                        })
                    }
                    if (t.removeAttribute(e),
                    e === "is" && !T[e])
                        if ($ || ue)
                            try {
                                D(t)
                            } catch {}
                        else
                            try {
                                t.setAttribute(e, "")
                            } catch {}
                }
                  , Et = function(e) {
                    let t = null
                      , i = null;
                    if (Re)
                        e = "<remove></remove>" + e;
                    else {
                        let y = ze(e, /^[\r\n\t ]+/);
                        i = y && y[0]
                    }
                    ne === "application/xhtml+xml" && j === P && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
                    let d = L ? L.createHTML(e) : e;
                    if (j === P)
                        try {
                            t = new rn().parseFromString(d, ne)
                        } catch {}
                    if (!t || !t.documentElement) {
                        t = Ae.createDocument(j, "template", null);
                        try {
                            t.documentElement.innerHTML = be ? Q : d
                        } catch {}
                    }
                    let I = t.body || t.documentElement;
                    return e && i && I.insertBefore(g.createTextNode(i), I.childNodes[0] || null),
                    j === P ? pn.call(t, B ? "html" : "body")[0] : B ? t.documentElement : I
                }
                  , Tt = function(e) {
                    return dn.call(e.ownerDocument || e, e, Z.SHOW_ELEMENT | Z.SHOW_COMMENT | Z.SHOW_TEXT | Z.SHOW_PROCESSING_INSTRUCTION | Z.SHOW_CDATA_SECTION, null)
                }
                  , Cn = function(e) {
                    return e instanceof an && (typeof e.__depth < "u" && typeof e.__depth != "number" || typeof e.__removalCount < "u" && typeof e.__removalCount != "number" || typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || !(e.attributes instanceof sn) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function")
                }
                  , At = function(e) {
                    return typeof Te == "function" && e instanceof Te
                }
                  , x = function(e, t, i) {
                    N[e] && ie(N[e], d => {
                        d.call(s, t, i, Y)
                    }
                    )
                }
                  , St = function(e) {
                    let t = null;
                    if (x("beforeSanitizeElements", e, null),
                    Cn(e))
                        return D(e),
                        !0;
                    let i = A(e.nodeName);
                    if (x("uponSanitizeElement", e, {
                        tagName: i,
                        allowedTags: E
                    }),
                    e.hasChildNodes() && !At(e.firstElementChild) && w(/<[/\w]/g, e.innerHTML) && w(/<[/\w]/g, e.textContent) || e.nodeType === 7 || st && e.nodeType === 8 && w(/<[/\w]/g, e.data))
                        return D(e),
                        !0;
                    if (!E[i] || ee[i]) {
                        if (!ee[i] && yt(i) && (_.tagNameCheck instanceof RegExp && w(_.tagNameCheck, i) || _.tagNameCheck instanceof Function && _.tagNameCheck(i)))
                            return !1;
                        if (Oe && !q[i]) {
                            let d = J(e) || e.parentNode
                              , I = un(e) || e.childNodes;
                            if (I && d) {
                                let y = I.length;
                                for (let C = y - 1; C >= 0; --C) {
                                    let R = ln(I[C], !0);
                                    R.__removalCount = (e.__removalCount || 0) + 1,
                                    d.insertBefore(R, cn(e))
                                }
                            }
                        }
                        return D(e),
                        !0
                    }
                    return e instanceof Ze && !wn(e) || (i === "noscript" || i === "noembed" || i === "noframes") && w(/<\/no(script|embed|frames)/i, e.innerHTML) ? (D(e),
                    !0) : (z && e.nodeType === 3 && (t = e.textContent,
                    ie([Se, Ie, ye], d => {
                        t = K(t, d, " ")
                    }
                    ),
                    e.textContent !== t && (W(s.removed, {
                        element: e.cloneNode()
                    }),
                    e.textContent = t)),
                    x("afterSanitizeElements", e, null),
                    !1)
                }
                  , It = function(e, t, i) {
                    if (at && (t === "id" || t === "name") && (i in g || i in yn))
                        return !1;
                    if (!(we && !Le[t] && w(gn, t))) {
                        if (!(nt && w(hn, t))) {
                            if (!T[t] || Le[t]) {
                                if (!(yt(e) && (_.tagNameCheck instanceof RegExp && w(_.tagNameCheck, e) || _.tagNameCheck instanceof Function && _.tagNameCheck(e)) && (_.attributeNameCheck instanceof RegExp && w(_.attributeNameCheck, t) || _.attributeNameCheck instanceof Function && _.attributeNameCheck(t)) || t === "is" && _.allowCustomizedBuiltInElements && (_.tagNameCheck instanceof RegExp && w(_.tagNameCheck, i) || _.tagNameCheck instanceof Function && _.tagNameCheck(i))))
                                    return !1
                            } else if (!Me[t]) {
                                if (!w(Qe, K(i, Je, ""))) {
                                    if (!((t === "src" || t === "xlink:href" || t === "href") && e !== "script" && Gt(i, "data:") === 0 && ct[e])) {
                                        if (!(ot && !w(_n, K(i, Je, "")))) {
                                            if (i)
                                                return !1
                                        }
                                    }
                                }
                            }
                        }
                    }
                    return !0
                }
                  , yt = function(e) {
                    return e !== "annotation-xml" && ze(e, En)
                }
                  , Lt = function(e) {
                    x("beforeSanitizeAttributes", e, null);
                    let {attributes: t} = e;
                    if (!t)
                        return;
                    let i = {
                        attrName: "",
                        attrValue: "",
                        keepAttr: !0,
                        allowedAttributes: T
                    }
                      , d = t.length;
                    for (; d--; ) {
                        let I = t[d]
                          , {name: y, namespaceURI: C, value: R} = I
                          , oe = A(y)
                          , O = y === "value" ? R : zt(R);
                        if (i.attrName = oe,
                        i.attrValue = O,
                        i.keepAttr = !0,
                        i.forceKeepAttr = void 0,
                        x("uponSanitizeAttribute", e, i),
                        O = i.attrValue,
                        i.forceKeepAttr || (Ne(y, e),
                        !i.keepAttr))
                            continue;
                        if (!it && w(/\/>/i, O)) {
                            Ne(y, e);
                            continue
                        }
                        z && ie([Se, Ie, ye], Ct => {
                            O = K(O, Ct, " ")
                        }
                        );
                        let wt = A(e.nodeName);
                        if (It(wt, oe, O)) {
                            if (rt && (oe === "id" || oe === "name") && (Ne(y, e),
                            O = Tn + O),
                            L && typeof le == "object" && typeof le.getAttributeType == "function" && !C)
                                switch (le.getAttributeType(wt, oe)) {
                                case "TrustedHTML":
                                    {
                                        O = L.createHTML(O);
                                        break
                                    }
                                case "TrustedScriptURL":
                                    {
                                        O = L.createScriptURL(O);
                                        break
                                    }
                                }
                            try {
                                C ? e.setAttributeNS(C, y, O) : e.setAttribute(y, O),
                                Ge(s.removed)
                            } catch {}
                        }
                    }
                    x("afterSanitizeAttributes", e, null)
                }
                  , Rn = function a(e) {
                    let t = null
                      , i = Tt(e);
                    for (x("beforeSanitizeShadowDOM", e, null); t = i.nextNode(); ) {
                        if (x("uponSanitizeShadowNode", t, null),
                        St(t))
                            continue;
                        let d = J(t);
                        t.nodeType === 1 && (d && d.__depth ? t.__depth = (t.__removalCount || 0) + d.__depth + 1 : t.__depth = 1),
                        t.__depth >= ft && D(t),
                        t.content instanceof k && (t.content.__depth = t.__depth,
                        a(t.content)),
                        Lt(t)
                    }
                    x("afterSanitizeShadowDOM", e, null)
                };
                return s.sanitize = function(a) {
                    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
                      , t = null
                      , i = null
                      , d = null
                      , I = null;
                    if (be = !a,
                    be && (a = "<!-->"),
                    typeof a != "string" && !At(a))
                        if (typeof a.toString == "function") {
                            if (a = a.toString(),
                            typeof a != "string")
                                throw X("dirty is not a string, aborting")
                        } else
                            throw X("toString is not a function");
                    if (!s.isSupported)
                        return a;
                    if (Ce || De(e),
                    s.removed = [],
                    typeof a == "string" && (te = !1),
                    te) {
                        if (a.nodeName) {
                            let R = A(a.nodeName);
                            if (!E[R] || ee[R])
                                throw X("root node is forbidden and cannot be sanitized in-place")
                        }
                    } else if (a instanceof Te)
                        t = Et("<!---->"),
                        i = t.ownerDocument.importNode(a, !0),
                        i.nodeType === 1 && i.nodeName === "BODY" || i.nodeName === "HTML" ? t = i : t.appendChild(i);
                    else {
                        if (!$ && !z && !B && a.indexOf("<") === -1)
                            return L && de ? L.createHTML(a) : a;
                        if (t = Et(a),
                        !t)
                            return $ ? null : de ? Q : ""
                    }
                    t && Re && D(t.firstChild);
                    let y = Tt(te ? a : t);
                    for (; d = y.nextNode(); ) {
                        if (St(d))
                            continue;
                        let R = J(d);
                        d.nodeType === 1 && (R && R.__depth ? d.__depth = (d.__removalCount || 0) + R.__depth + 1 : d.__depth = 1),
                        d.__depth >= ft && D(d),
                        d.content instanceof k && (d.content.__depth = d.__depth,
                        Rn(d.content)),
                        Lt(d)
                    }
                    if (te)
                        return a;
                    if ($) {
                        if (ue)
                            for (I = fn.call(t.ownerDocument); t.firstChild; )
                                I.appendChild(t.firstChild);
                        else
                            I = t;
                        return (T.shadowroot || T.shadowrootmode) && (I = mn.call(p, I, !0)),
                        I
                    }
                    let C = B ? t.outerHTML : t.innerHTML;
                    return B && E["!doctype"] && t.ownerDocument && t.ownerDocument.doctype && t.ownerDocument.doctype.name && w(We, t.ownerDocument.doctype.name) && (C = "<!DOCTYPE " + t.ownerDocument.doctype.name + `>
` + C),
                    z && ie([Se, Ie, ye], R => {
                        C = K(C, R, " ")
                    }
                    ),
                    L && de ? L.createHTML(C) : C
                }
                ,
                s.setConfig = function() {
                    let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    De(a),
                    Ce = !0
                }
                ,
                s.clearConfig = function() {
                    Y = null,
                    Ce = !1
                }
                ,
                s.isValidAttribute = function(a, e, t) {
                    Y || De({});
                    let i = A(a)
                      , d = A(e);
                    return It(i, d, t)
                }
                ,
                s.addHook = function(a, e) {
                    typeof e == "function" && (N[a] = N[a] || [],
                    W(N[a], e))
                }
                ,
                s.removeHook = function(a) {
                    if (N[a])
                        return Ge(N[a])
                }
                ,
                s.removeHooks = function(a) {
                    N[a] && (N[a] = [])
                }
                ,
                s.removeAllHooks = function() {
                    N = {}
                }
                ,
                s
            }
            var on = Xe();
            return on
        })
    }
    );
    var Ut = Pn(Ot());
    var Mt = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_466_934)">
  <path d="M5.41675 10.8333L6.07046 12.1408C6.2917 12.5832 6.40232 12.8045 6.55011 12.9962C6.68124 13.1663 6.83375 13.3188 7.00388 13.45C7.19559 13.5977 7.41684 13.7084 7.85932 13.9296L9.16675 14.5833L7.85932 15.237C7.41684 15.4583 7.19559 15.5689 7.00388 15.7167C6.83375 15.8478 6.68124 16.0003 6.55011 16.1704C6.40232 16.3622 6.2917 16.5834 6.07046 17.0259L5.41675 18.3333L4.76303 17.0259C4.54179 16.5834 4.43117 16.3622 4.28339 16.1704C4.15225 16.0003 3.99974 15.8478 3.82962 15.7167C3.6379 15.5689 3.41666 15.4583 2.97418 15.237L1.66675 14.5833L2.97418 13.9296C3.41666 13.7084 3.6379 13.5977 3.82962 13.45C3.99974 13.3188 4.15225 13.1663 4.28339 12.9962C4.43117 12.8045 4.54179 12.5832 4.76303 12.1408L5.41675 10.8333Z" stroke="#181825" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.5001 1.66666L13.4823 4.22034C13.7173 4.83136 13.8348 5.13688 14.0175 5.39386C14.1795 5.62162 14.3785 5.82061 14.6062 5.98256C14.8632 6.16529 15.1687 6.2828 15.7797 6.5178L18.3334 7.49999L15.7797 8.48217C15.1687 8.71718 14.8632 8.83469 14.6062 9.01742C14.3785 9.17937 14.1795 9.37836 14.0175 9.60612C13.8348 9.8631 13.7173 10.1686 13.4823 10.7796L12.5001 13.3333L11.5179 10.7796C11.2829 10.1686 11.1654 9.8631 10.9827 9.60612C10.8207 9.37836 10.6217 9.17937 10.3939 9.01742C10.137 8.83469 9.83145 8.71718 9.22043 8.48217L6.66675 7.49999L9.22043 6.5178C9.83145 6.28279 10.137 6.16529 10.3939 5.98256C10.6217 5.82061 10.8207 5.62162 10.9827 5.39386C11.1654 5.13688 11.2829 4.83136 11.5179 4.22034L12.5001 1.66666Z" stroke="#181825" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
  <clipPath id="clip0_466_934">
    <rect width="20" height="20" fill="white"/>
  </clipPath>
</defs>
</svg>
`;
    var xe = () => {
        let n = Un();
        return n !== void 0 ? n : window.Shopify?.locale !== void 0 ? window.Shopify.locale : "en"
    }
      , bt = n => {
        let o = n ?? window.Shopify?.locale
          , l = document.getElementById("dialog-shopify-ai");
        if (l === null || o === void 0)
            return;
        let r = xn(o);
        r !== null && (l.dataset.locale = r.formatted,
        l.dataset.shopIsoCode = r.formatted,
        l.dataset.language = r.language,
        l.dataset.countryCode = r.countryCode,
        window.DIALOG_VARIABLES.locale = r.formatted)
    }
    ;
    var xn = n => {
        try {
            let o = new Intl.Locale(n)
              , l = o.language
              , r = o.region ?? o.maximize().region
              , c = new Intl.DisplayNames(["en"],{
                type: "language"
            }).of(l);
            return c === void 0 || r === void 0 ? null : {
                language: c,
                countryCode: r,
                formatted: l
            }
        } catch {
            return null
        }
    }
      , Un = () => document.getElementsByTagName("html")[0].getAttribute("lang")?.slice(0, 2) ?? void 0;
    var Hn = "ANONYMOUS_CUSTOMER_ID"
      , Fn = "CUSTOMER_ID";
    var vt = () => {
        let n = localStorage.getItem(Hn);
        return localStorage.getItem(Fn) ?? n
    }
    ;
    var Dt = "phc_EKMR6Jt4OTMEYmoUlz0v58KPwqcFxI7aZCLckpSD8Tv"
      , Bn = "https://eu.i.posthog.com"
      , Gn = `ph_${Dt}_posthog`;
    var zn = () => {
        let n = localStorage.getItem(Gn);
        if (n === null)
            return;
        let {distinct_id: o, $client_session_props: l, $enabled_feature_flags: r} = JSON.parse(n);
        return {
            distinct_id: o,
            $client_session_props: l,
            $enabled_feature_flags: r
        }
    }
      , $n = n => {
        let o = Object.keys(n ?? {})
          , l = {};
        return o.forEach(r => {
            l[`$feature/${r}`] = n?.[r] ?? ""
        }
        ),
        l
    }
      , Nt = async (n, o) => {
        let {distinct_id: l, $client_session_props: r, $enabled_feature_flags: h} = zn() ?? {};
        await fetch(`${Bn}/capture`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                api_key: Dt,
                event: n,
                distinct_id: l,
                properties: {
                    $host: window.location.host,
                    $pathname: window.location.pathname,
                    $session_id: r?.sessionId,
                    ...$n(h),
                    ...o
                }
            })
        })
    }
    ;
    var kt = n => {
        let o = vt();
        o !== null && Nt("user_seen_dialog", {
            apiKey: window.DIALOG_VARIABLES.apiKey,
            sessionId: o,
            buttonType: n
        })
    }
    ;
    var Ht = "phc_EKMR6Jt4OTMEYmoUlz0v58KPwqcFxI7aZCLckpSD8Tv"
      , Vn = "https://eu.i.posthog.com"
      , qn = `ph_${Ht}_posthog`
      , jn = n => {
        let o = n.target
          , l = document.querySelector(".dialog-input-submit");
        l !== null && (l.disabled = o.value.trim() === "")
    }
      , Ft = () => {
        let n = document.getElementById("dialog-shopify-ai-product")
          , o = document.getElementById("dialog-instant");
        if (o === null)
            return;
        let l = o.dataset.productId ?? window.DIALOG_PRODUCT_VARIABLES?.productId ?? ""
          , r = document.querySelector(".dialog-ask-anything-input");
        r && r.addEventListener("input", jn);
        let h = o.querySelectorAll(`.dialog-suggestion[data-product-id='${l}']`)
          , c = document.querySelector(".dialog-input-submit");
        n === null || r === null || c === null || h.length === 0 || (Kn(n),
        r.addEventListener("keypress", u => {
            u.key === "Enter" && Pt(n, r)(u)
        }
        ),
        c.addEventListener("click", Pt(n, r)),
        h.forEach( (u, H) => {
            u.addEventListener("click", Yn(n, H))
        }
        ))
    }
      , Bt = (n, o) => {
        let l = localStorage.getItem(qn);
        if (l === null)
            return;
        let {distinct_id: r, $client_session_props: h} = JSON.parse(l);
        fetch(`${Vn}/capture`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                api_key: Ht,
                event: n,
                distinct_id: r,
                properties: {
                    ...o,
                    $session_id: h?.sessionId,
                    $host: document.location.host,
                    $pathname: document.location.pathname
                }
            })
        })
    }
      , Pt = (n, o) => l => {
        l.preventDefault();
        let r = document.getElementById("send-message-button");
        if (r === null || o.value.trim().length === 0)
            return;
        n.dataset.question = o.value;
        let c = new URLSearchParams(window.location.search).get("variant")
          , u = new CustomEvent("enableDialogAssistantEvent",{
            detail: {
                type: "PRODUCT_QUESTION",
                payload: {
                    question: n.dataset.question,
                    productId: n.dataset.productId,
                    productTitle: n.dataset.productTitle,
                    handle: n.dataset.handle,
                    selectedVariantId: c ?? n.dataset.selectedVariantId
                }
            }
        });
        window.dispatchEvent(u),
        Bt("user_sent_custom_message", {
            message: n.dataset.question
        }),
        o.blur(),
        o.value = "",
        r.disabled = !0
    }
      , Yn = (n, o) => l => {
        l.preventDefault();
        let r = document.getElementById("dialog-suggestions-container");
        if (r === null)
            return;
        let h = r.children[o]
          , c = h.dataset.value
          , u = h.dataset.answer;
        n.dataset.question = c,
        n.dataset.answer = u;
        let b = new URLSearchParams(window.location.search).get("variant")
          , U = new CustomEvent("enableDialogAssistantEvent",{
            detail: {
                type: "PRODUCT_QUESTION",
                payload: {
                    question: c,
                    answer: u,
                    productId: n.dataset.productId,
                    handle: n.dataset.handle,
                    fromQuestionSuggestion: !0,
                    productTitle: n.dataset.productTitle,
                    selectedVariantId: b ?? n.dataset.selectedVariantId
                }
            }
        });
        window.dispatchEvent(U),
        Bt("user_clicked_suggestion", {
            question: c ?? ""
        })
    }
      , Ue = 0
      , Fe = async n => {
        let o = ++Ue
          , l = document.getElementById("dialog-instant");
        if (l === null) {
            Be();
            return
        }
        let r = l.dataset.productId ?? window.DIALOG_PRODUCT_VARIABLES?.productId ?? ""
          , h = window.location.pathname.split("?")[0];
        await fetch(`/apps/dialog/ai/product-questions?pagePath=${h}&locale=${n}&productId=${r}`, {
            headers: {
                Authorization: window.DIALOG_VARIABLES.apiKey
            }
        }).then(c => c.json()).then(c => {
            if (o !== Ue) {
                console.log("ignoring outdated suggestions response");
                return
            }
            if (c.assistantName !== void 0) {
                let u = document.getElementById("assistant-name");
                u !== null && (u.innerHTML = c.assistantName)
            }
            if (c.description !== void 0) {
                let u = document.getElementById("description");
                u !== null && (u.innerHTML = c.description)
            }
            if (c.inputPlaceholder !== void 0) {
                let u = document.getElementById("dialog-ask-anything-input");
                u !== null && (u.placeholder = c.inputPlaceholder)
            }
            c.questions !== void 0 && (c.questions.slice(0, 2).forEach( (u, H) => {
                let b = document.querySelector(`#dialog-instant[data-product-id="${r}"] #dialog-suggestion-${H}`);
                if (b !== null) {
                    b.dataset.productId = r,
                    b.style.width = "fit-content",
                    b.dataset.value = u.question,
                    u.answer !== void 0 && (b.dataset.answer = u.answer);
                    let U = Ut.default.sanitize(u.question);
                    b.innerHTML = `${Mt}<span data-value="${U}">${U}</span>`
                }
            }
            ),
            Be())
        }
        ).catch(c => {
            if (o !== Ue)
                return;
            let u = document.getElementById("dialog-instant");
            u !== null && (u.style.display = "none"),
            console.error("Error:", c)
        }
        )
    }
      , Wn = n => o => {
        let r = new URLSearchParams(window.location.search).get("variant")
          , h = new CustomEvent("enableDialogAssistantEvent",{
            detail: {
                type: "START_DIAGNOSTIC",
                payload: {
                    buttonType: "simpleButtonDiagnostic",
                    productId: n.dataset.productId,
                    handle: n.dataset.handle,
                    productTitle: n.dataset.productTitle,
                    selectedVariantId: r ?? n.dataset.selectedVariantId
                }
            }
        });
        window.dispatchEvent(h)
    }
      , Kn = n => {
        let o = document.getElementById("dialog-diagnostic-btn");
        o !== null && o.addEventListener("click", Wn(n))
    }
      , Xn = n => {
        let o = n?.cloneNode(!0);
        n?.remove(),
        o !== void 0 && document.body.appendChild(o)
    }
      , Zn = 3
      , He = 0
      , Be = () => {
        let n = document.getElementsByTagName("body")[0];
        if (He >= Zn)
            return;
        He += 1;
        let o = new MutationObserver(l => {
            (async () => {
                for (let r of l)
                    if (r.type === "childList") {
                        let h = document.querySelector(".dialog-suggestion-skeleton");
                        if (document.getElementById("dialog-instant") === null) {
                            He = 0;
                            return
                        }
                        if (h !== null) {
                            console.log("Skeleton suggestions detected, reloading suggestions"),
                            o.disconnect(),
                            await Fe(xe()),
                            Ft(),
                            setTimeout( () => {
                                Be()
                            }
                            , 500);
                            break
                        }
                    }
            }
            )()
        }
        );
        o.observe(n, {
            childList: !0,
            subtree: !0,
            characterData: !0,
            attributes: !0
        })
    }
      , xt = async () => {
        let n = document.getElementById("dialog-shopify-ai-product");
        Xn(n),
        window.Weglot !== void 0 && window.Weglot.on("languageChanged", o => {
            (async () => (await Fe(o),
            bt(o)))()
        }
        ),
        await Fe(xe()),
        Ft(),
        kt("suggestionsButtons")
    }
    ;
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", () => {
        xt()
    }
    ) : xt();
}
)();
/*! Bundled license information:

dompurify/dist/purify.js:
  (*! @license DOMPurify 3.1.2 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.2/LICENSE *)
*/
